// @ts-nocheck

// import 'core-js/es5';
import 'babel-polyfill';
import React, {useState, useEffect, useRef, Suspense} from 'react';
import * as ReactDOM from 'react-dom';
import WindowDimensionsProvider from './WindowDimensionsProvider';
import UrlPattern from 'url-pattern';
// @ts-ignore
import UrlPolyfill from 'url-polyfill';
import CreateComponent from '../utils/CreateComponent';
import History from '../utils/BrowserHistory';
import Empty from './Empty';
import styles from './App.scss';
import Animations from '../utils/Animations';

import AppState from '../utils/AppState';
import UtmCampaign from '../utils/utmCampaign';
import {useInitUser} from "./auth/useUser";
import Config from "../utils/Config";
import Cart from "./commerce/Cart";
import Checkout from "./commerce/Checkout";
import {BrowserRouter, Route, Router, Routes} from "react-router-dom";
import CheckoutLogin from "./commerce/CheckoutLogin";


const ThemeProvider = React.lazy(() => import(/* webpackChunkName: "misc1" */ './mui/ThemeProvider'));

// const EditProperty = React.lazy(() => import(/* webpackChunkName: "misc" */ '../components/NewProperty/EditProperty'));


const x = UrlPolyfill;

const base = document.querySelector('base');
let baseUrl = (base && base.href) || '/';
const a = document.createElement('a');
a.href = baseUrl;
baseUrl = a.pathname;

Animations.init();
CreateComponent.init();

// use UrlPattern

export interface IAppProps {
}

function App() {
  const [{pathname, state}, setPathname] = useState(History.location);
  const [, userActions] = useInitUser();

  const handlePageShow = (ev: any) => {
    console.log("Drupal Settings: ", Config.getDrupalSettings());
    // fix safari cache on back button #1732, #2033
    // https://stackoverflow.com/questions/8788802/prevent-safari-loading-from-cache-when-back-button-is-clicked
    if (ev.persisted) {
      // back button in safari was used, so last app state is cached
      console.log('APP-onpageshow wasPersistedPageShow');

      // test for wasPersistedPageShow in component to avoid actions after user status update
      AppState.set('wasPersistedPageShow', true);

      userActions.refreshStatus();

      // clear wasPersistedPageShow
      setTimeout(() => {
        AppState.set('wasPersistedPageShow', null);
      }, 1000);
    } else {
      userActions.refreshStatus();
      AppState.set('wasPersistedPageShow', false);
    }
  };
  useEffect(() => {
    window.addEventListener('pageshow', handlePageShow);
    UtmCampaign.setFromUrl(location.href);

    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, []);

  useEffect(() => {
    const unlisten = History.listen(({location}) => {
      if (location.pathname !== pathname || location.state != state) {
        setPathname(location);
      }
    });
    return unlisten;
  }, [pathname, state]);



  return (
    <Suspense fallback={<div>Loading...</div>}>
      <ThemeProvider>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Routes>
            <Route path="/cart" element={<Cart />} />
            <Route path="/cart-login" element={<CheckoutLogin />} />
            <Route path="/cart-checkout" element={<Checkout />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </Suspense>
  );
}

/* IE11 Polyfill for elm.remove() */
// from:https://stackoverflow.com/questions/43756244/childnode-remove-polyfill-with-babel-polyfill
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        this.parentNode.removeChild(this);
      },
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

/* https://stackoverflow.com/questions/56468914/ie11-attempt-to-use-the-method-flat-polyfill-causes-error-within-the-polyfill */
if (!Array.isArray) {
  /* @ts-ignore */
  Array.isArray = function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
  };
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/flat#Polyfill
/* @ts-ignore */
if (!Array.prototype.flat) {
  /* @ts-ignore */
  Array.prototype.flat = function (depth) {
    const flattened = [];
    (function flat(array, depth) {
      /* @ts-ignore */
      for (let i = 0; i < array.length; i++) {
        const el = array[i];
        if (Array.isArray(el) && depth > 0) {
          /* @ts-ignore */
          flat(el, depth - 1);
        } else {
          flattened.push(el);
        }
      }
    })(this, Math.floor(depth) || 1);
    return flattened;
  };
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
Number.isInteger =
  Number.isInteger ||
  function (value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

// export default hot(module)(App);
export default App;
